import Principal from '../screens/Principal.vue'
import CadastrarEmpresa from '../screens/CadastrarEmpresa.vue'
import ListaEmpresa from '../screens/ListaEmpresa.vue'
import OpCadList from '../screens/OpCadList.vue'
import  BaixarNota from '../screens/BaixarNota.vue'
import NotaCompleta from '../screens/NotaCompleta.vue'
import Importar from '../screens/Importar.vue'
import All from '../screens/All.vue'
export const routes = [     
    {path:'/arqlef',name:'principal', component: Principal},    
    {path:'/arqlef/notacompleta',name:'notacompleta', component: NotaCompleta},    
    {path:'/arqlef/cadastro',name:'cadastrarempresa', component: CadastrarEmpresa},  
    {path:'/arqlef/empresas',name:'empresas', component: ListaEmpresa},
    {path:'/arqlef/escolha',name:'escolha', component: OpCadList},
    {path:'/arqlef/notas',name:'notas', component: All},
    {path:'/arqlef/baixar',name:'baixar', component: BaixarNota},
    {path:'/arqlef/importar',name:'importar', component: Importar},
];